import gql from 'graphql-tag';
import {
  subscriptionPlanFragments,
  userFragments
} from '../fragments';

const userQueries = {
  UserSearch: (options) => {
    return gql`
      query {
        userSearch (
          input: {
            searchTerm: "${options.searchTerm}"
            limit: ${options.limit}
            offset: ${options.offset}
            orderBy: "${options.orderBy}"
            orderByDirection: "${options.orderByDirection}"
          }
        ) {
          count
          users {
            id
            firstName
            lastName
            fullNameAdmin
            email
            type
            dateCreated
          }
        }
      }
    `;
  },
  UserById: (id) => {
    return gql`
      query {
        userById (id: ${id}) {
          id
          firstName
          lastName
          fullName
          email
          type
          dateCreated
          stripeCustomerId
          stripePaymentMethodId
          currency
          language
          tags {
            id
            name
            tagGroup {
              id
              name
            }
          }
        }
      }
    `;
  },
  UserByGiftedToId: gql`
    query (
      $id: Int!
    ) {
      userByGiftedToId (
        id: $id
      ) {
        id
        firstName
        lastName
        email
      }
    }`,
  UserByToken: (token) => {
    return gql`
      query {
        userByToken (token: "${token}") {
          ...FullUser
          token
        }
      }
      ${userFragments.fullUser}
    `;
  },
  // uses the jwt to get the user details
  CurrentUser: gql`
    query {
      currentUser {
        ...FullUser
      }
    }
    ${userFragments.fullUser}
  `,
  UserPurchases: gql`
    query ($id: Int) {
      userPurchases (id: $id) {
        ...FullUser
        purchases {
          id
          status
          purchaseDate
          totalPrice
          totalPriceFormatted
          currency
          paymentType
          purchaseItems {
            id
            price
            discount
            discountType
            giftedToUserId
            subscriptionPlan {
              id
              type
              subscription {
                id
                title
              }
            }
            product {
              id
              type
              title
              language
              images
              tagsCache
              priceLocalFormatted
              author {
                id
                fullName
              }
            }
          }
        }
      }
    }
    ${userFragments.fullUser}
  `,
  UserSubscriptionPlans: gql`
    query {
      userSubscriptionPlans {
        id
        startDateTime
        endDateTime
        subscriptionPlan {
          ...FullSubscriptionPlan
          subscription {
            id
            title
          }
        }
      }
    }
    ${subscriptionPlanFragments.fullSubscriptionPlan}
  `,
  Publishers: gql`
    query {
      publishers {
        id
        fullName
      }
    }
  `
};

export default userQueries;
